import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=34a837e0&"
import script from "./Permissions.vue?vue&type=script&lang=ts&"
export * from "./Permissions.vue?vue&type=script&lang=ts&"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=34a837e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports